import React from 'react';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import "./Add_Complaint.css"
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FiberTeam_Complaint from './FiberTeam_Complaint';
import NetworkTeam_Complaint from './NetworkTeam_Complaint';
import axios from 'axios';

export default function WorkAssign_Complaint({complaintDetails, setComplaintDetails,  isSubmitting,
  fiberTeamStock,
  setFiberTeamStock,
  networkTeamStock,
  setNetworkTeamStock,
activeTabWorkAssign,
setActiveTabWorkAssign}) {
        // const [activeTabWorkAssign, setActiveTabWorkAssign] = useState("fiberTeam");


  const locate = useLocation();
        const apiUrl = process.env.REACT_APP_API_BASE_URL;
         useEffect(() => {
                      axios
                        .post(apiUrl+"get-complaint", {
                          id: locate.state?.id,
                        })
                        .then((res) => {
                          setComplaintDetails(res.data.message);
                           // Store original data for comparison
                        });
                    }, [locate.state?.id]);

         const renderContentWorkAssign = () => {
                switch (activeTabWorkAssign) {
                    case "fiberTeam":
                        return <div>
        
                     <FiberTeam_Complaint isSubmitting={isSubmitting}  complaintDetails={complaintDetails} setComplaintDetails={setComplaintDetails}  stock={fiberTeamStock} setStock={setFiberTeamStock}/>
                        </div>;
                    case "networkTeam":
                        return <div>
                          <NetworkTeam_Complaint isSubmitting={isSubmitting} complaintDetails={complaintDetails} setComplaintDetails={setComplaintDetails}  stock={networkTeamStock} setStock={setNetworkTeamStock}/>
                        </div>;
                
                    default:
                        return <div>Select a tab</div>;
                }
            };
    
  return (
    <div className="tabs-container-workassign mt-3">
    {/* Tabs */}
    <div className="tabs-wokassign">
       <Row>
  {complaintDetails?.complaintfiber && (
    <button
      className={`fiber-button-workassign ${activeTabWorkAssign === "fiberTeam" ? "active-tab" : ""}`}
      type="button"
      onClick={() => setActiveTabWorkAssign("fiberTeam")}
    >
      Fiber Team
    </button>
  )}

  {complaintDetails?.complaintnetwork && (
    <button
      className={`fiber-button-workassign ${complaintDetails?.complaintfiber ? "ms-5" : ""} ${activeTabWorkAssign === "networkTeam" ? "active-tab" : ""}`}
      type="button"
      onClick={() => setActiveTabWorkAssign("networkTeam")}
    >
      Network Team
    </button>
  )}
</Row>

            
    </div>

    {/* Dynamic Content */}
    <div className='fiber-workassign mt-3'>

        {renderContentWorkAssign()}






    </div>



</div>

  )
}
